@if (vm.showTodaySelection) {
<section class="today-checkbox-wrapper">
  <label class="today-checkbox-label">
    <input
      type="checkbox"
      [checked]="checkedTodaysDate()"
      (change)="onCheckboxChanged($event)"
    />
    <p class="label">Today ({{ formattedTodaysDate | date : 'd MMMM y' }})</p>
  </label>
</section>
}

<!--if they want to see today checkbox AND its not selected, show calendar picker -->
@if ((vm.showTodaySelection && !vm.checkedTodaysDate) || !vm.showTodaySelection)
{
<section class="flex full-width navigation mb-8 mt-16">
  <p class="heading-5">
    {{ vm.displayMonth }}
    @if (vm.showSelectedYear) {
    {{ vm.selectedYear }}
    }
  </p>

  <section class="action">
    <button
      type="button"
      (click)="moveMonthBack()"
      [disabled]="disabled || !vm.canGoBackwards || vm.loading"
    >
      <i class="fa-light fa-chevron-left"></i>
    </button>
    <button
      type="button"
      (click)="moveMonthForward()"
      [disabled]="disabled || !vm.canGoForward || vm.loading"
    >
      <i class="fa-light fa-chevron-right"></i>
    </button>
  </section>
</section>

<section class="calendar-holder">
  <section class="calendar-heading">
    @for (weekday of daysToDisplay; track weekday) {
    <section class="day pt-8 pb-8">
      <p class="hint">
        {{ weekday }}
      </p>
    </section>
    }
  </section>
  <section class="week-holder">
    @for (week of vm.weekInMonth; track week) {
    <section class="week">
      @for (day of week; track day) {
      <button
        type="button"
        class="day body large"
        [disabled]="disabled"
        [tabIndex]="inCalendarView ? -1 : 0"
        [class.selected]="value === day.date"
        [class.inCurrentMonth]="day.isCurrentMonth"
        [class.isActive]="day.isActive"
        [attr.data-iscurrentmonth]="day.isCurrentMonth"
        (click)="day.isActive ? writeValue(day.date) : null"
      >
        {{ day.date | date : 'd' }}
      </button>
      }
    </section>
    } @if (vm.loading) {
    <section class="loading-dates">
      <app-loading-spinner variant="grey" [strokeWidth]="4" [size]="40" />
      <p class="body bold">Our calendar’s loading…</p>
    </section>
    }
  </section>
</section>
}
